/**
 * This patch changes old form file uploads nodes removing deprecated 'version' field
 */

import * as DomTypeUtils from '@packages/systems/core/utils/DomTypeUtils';
import type {Context} from '../types';

export default (context: Context) => {
  const {
    node: {jsonNode},
  } = context;

  const {data = {}} = jsonNode;

  const isFormFileUploadLabel = DomTypeUtils.isFormFileUploadLabel(data);
  const isFormFileUploadUploadingBtn =
    DomTypeUtils.isFormFileUploadUploadingBtn(data);
  const isVersionedNode = data.form && Boolean(data.form.version);

  return {
    needed:
      (isFormFileUploadLabel || isFormFileUploadUploadingBtn) &&
      isVersionedNode,
    logData: {
      msg: 'Form File Upload node has version in `node.data.form`',
      meta: {
        nodeId: jsonNode._id,
      },
    },
    apply: () => {
      // eslint-disable-next-line webflow/no-delete
      delete data.form.version;
    },
  };
};
